/**
 * Name for the dashboard greeting, as Admin v2 writes it: the given name, with
 * a Malaysian honorific or title kept in front ("Good morning, Dr Farah",
 * "Encik Faizal", "Dato' Rahim", "Cik Mei Ling", "Nurul").
 */
const TITLES = [
  'tan sri',
  'puan sri',
  'datuk seri',
  'dato seri',
  "dato' seri",
  'dr',
  'dr.',
  'prof',
  'prof.',
  'dato',
  "dato'",
  'datuk',
  'datin',
  'tuan',
  'puan',
  'encik',
  'cik',
  'mr',
  'mrs',
  'ms',
];

export function greetingName(fullName: string): string {
  const words = fullName.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  // Longest title first (two words before one).
  for (const size of [2, 1]) {
    const head = words.slice(0, size).join(' ').toLowerCase();
    if (words.length > size && TITLES.includes(head)) {
      return [...words.slice(0, size), words[size]].join(' ');
    }
  }
  return words[0];
}

export function greetingKey(date: Date) {
  const h = date.getHours();
  if (h < 12) return 'shell.greetingMorning';
  if (h < 18) return 'shell.greetingAfternoon';
  return 'shell.greetingEvening';
}
